/**
 * Tính năng tạm ẩn trên một bản build (staging cho nhóm thử, chốt 22/10). `VITE_HIDDEN_FEATURES`
 * là các khoá dưới đây cách nhau dấu phẩy; để trống là đủ tính năng. Chỉ ẩn giao diện, API và
 * dữ liệu giữ nguyên. Nhánh `full-features` giữ bản đầy đủ để tham chiếu.
 */
export const FEATURES = {
  /** Đề thi thử. */
  mocks: "/mocks",
  /** Tab nhỏ "Bài Reading" trong Đề thi ETS. */
  "ets-reading": null,
  /** Nghe & chép. */
  dictation: "/dictation",
  /** Biểu đồ Part 1–4 trong Sổ tay lỗi sai. */
  "errors-listening": null,
  /** Thành tích và bình bong bóng trên thanh trên. */
  rewards: "/rewards",
  /** Game giờ nghỉ. */
  game: "/game",
} as const;
export type Feature = keyof typeof FEATURES;
const isFeature = (key: string): key is Feature => Object.hasOwn(FEATURES, key);
export function parseHidden(raw = ""): ReadonlySet<Feature> {
  return new Set(
    raw
      .split(",")
      .map((s) => s.trim())
      .filter(isFeature),
  );
}
export const HIDDEN = parseHidden(import.meta.env.VITE_HIDDEN_FEATURES);
export const featureOn = (feature: Feature) => !HIDDEN.has(feature);
/** Đường dẫn thuộc một trang đang ẩn (mở thẳng thì coi như không có trang). */
export function hiddenPath(path: string, hidden: ReadonlySet<Feature> = HIDDEN) {
  return [...hidden].some((f) => {
    const page = FEATURES[f];
    return !!page && (path === page || path.startsWith(`${page}/`));
  });
}
